export default "__VITE_ASSET__CbbPpjlO__"